<template>
    <fieldset>
        <legend class="cr-mb4">
            {{ challenge.description }}
        </legend>
        <cr-textarea v-model="model" required :rows="8" :label="t('CHALLENGE_FORM_DEFAULT_LABEL')"></cr-textarea>
    </fieldset>
</template>

<style scoped>
:deep(textarea),
:deep(label)::after
{
    background-color: transparent !important;
}
:deep(label)::before
{
    content: none !important;
}
.cr-textarea,
.cr-textarea :deep(textarea)
{
    font-size: var(--cr-input-text-size);
}
</style>

<script setup lang="ts">
import { IChallenge } from '@cyber-range/cyber-range-api-ctf-challenge-client';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
    challenge: IChallenge; 
    disabled?: boolean; 
}>();

const model = defineModel<string>();
</script>